import { getCurrencyValue } from "@components/Amount"


export const getPartnerTargetAmount = (context, createdBy, parameters) => {
  const { mutation } = parameters
  const { targetAmount } = mutation

  return getCurrencyValue(targetAmount)
}
